export default __webpack_public_path__ + "static/media/riverwalk_hero.91987f4f.jpg";